import axios from 'axios';

// Tworzymy instancję axiosa z podstawową konfiguracją
const api = axios.create({
    baseURL: 'http://localhost:5000/api', // URL twojego backendu
    headers: {
        'Content-Type': 'application/json'
    }
});

// Interceptor dla requestów - będzie dodawał token do każdego zapytania
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor dla odpowiedzi - obsłuży błędy autoryzacji
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 401) {
            // Jeśli serwer zwraca 401 (nieautoryzowany) - wyloguj użytkownika
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;